import gql from "graphql-tag";
import { ArticleBylineFragment, ArticleBylineAuthorFragment } from "types/api";
import styles from "./ArticleByline.module.scss";

function* createAuthors(
  authors: ArticleBylineAuthorFragment[],
  AuthorComponent: (props: ArticleBylineAuthorFragment) => JSX.Element
) {
  let i = 0;

  while (i < authors.length) {
    const author = authors[i];

    if (authors.length > 1 && i === authors.length - 1) {
      yield " and ";
    }

    if (author) {
      yield (<AuthorComponent {...author} key={author.id} />);
    }

    if (authors.length > 2 && i !== authors.length - 1) {
      yield ", ";
    }

    i += 1;
  }
}

const AuthorWrapper = ({ url, displayName }: ArticleBylineAuthorFragment) => {
  return (
    <a
      className={styles.link}
      href={url}
      data-action="click author - byline"
      data-label={url}
    >
      {displayName}
    </a>
  );
};

const ArticleByline = ({ authors }: ArticleBylineFragment) => {
  return (
    <address className={styles.root} id="byline">
      {Array.from(createAuthors(authors, AuthorWrapper))}
    </address>
  );
};

export default ArticleByline;

ArticleByline.fragment = gql`
  fragment articleBylineAuthor on Author {
    id
    url
    displayName
  }

  fragment articleByline on Article {
    authors {
      ...articleBylineAuthor
    }
  }
`;
